import { toast } from "react-toastify";
import { apiStart, apiSuccess } from "./apiActions";
import * as actionTypes from "./actionTypes";
import { catchHandler, errorHandler, successHandler } from "./responseHandler";
import api from "../../services";
import { getUserData } from "../../utils/localStorage";
import { getOnboardingPath, getRegPath } from "../../constants";
import {
  getDoctorDetails,
  setPersonalisedExperience,
} from "./physicianOnboardingActions";

import format from "date-fns/format";

// this file contains dummy data ignore this for review, will remove once all the apis get integrated from back-end

function encodeTokenBody(data) {
  let encoded = "";

  for (let [k, v] of Object.entries(data)) {
    encoded = encoded.concat("bank_account[" + k + "]", "=", encodeURI(v), "&");
  }
  return encoded;
}

function encodeBody(data) {
  let encoded = "";

  for (let [k, v] of Object.entries(data)) {
    encoded = encoded.concat(k, "=", encodeURI(v), "&");
  }
  return encoded;
}

//dummy add account api
export const addAccount = (cb = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(apiStart());

    const response = await fetch("https://api.stripe.com/v1/accounts", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      },
      body: encodeBody({
        type: "standard",
        email: "devweb5@yopmail.com",
        country: "US",
      }),
    });
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      dispatch(createBankAccountLink(ret.id, cb));
    } else {
      errorHandler(ret?.error?.message);
    }

    dispatch(apiSuccess());
  };
};

//dummy add account api
export const createPaymentIntent = (cb = () => {}) => {
  return async (dispatch, getState) => {
    const response = await fetch("https://api.stripe.com/v1/setup_intents", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      },
      body: encodeBody({
        "payment_method_options[card][request_three_d_secure]": "any",
      }),
    });

    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      cb(ret);
    } else {
      errorHandler(ret?.error?.message);
    }

    dispatch(apiSuccess());
  };
};

//dummy api to generate bank account token
export const generateBankAccountToken = cb => {
  return async (dispatch, getState) => {
    dispatch(apiStart());

    const response = await fetch("https://api.stripe.com/v1/tokens", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      },
      body: encodeTokenBody({
        country: "US",
        currency: "usd",
        account_holder_name: "Dinesh Panjwani",
        account_holder_type: "individual",
        account_number: "00123456789",
        routing_number: "110000000",
      }),
    });
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      dispatch(createBankAccount(ret.id, cb));
    } else {
      errorHandler(ret?.error?.message);
    }
    dispatch(apiSuccess());
  };
};

//dummy api to create bank account
export const createBankAccount = (token, cb) => {
  return async (dispatch, getState) => {
    dispatch(apiStart());

    const response = await fetch(
      "https://api.stripe.com/v1/accounts/" +
        localStorage.getItem("account_id") +
        "/external_accounts",
      {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
        body: encodeBody({
          external_account: token,
        }),
      }
    );
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      dispatch(createBankAccountLink(ret.id, cb));
    } else {
      errorHandler(ret?.error?.message);
    }
    dispatch(apiSuccess());
  };
};

export const createBankAccountLink = (id, cb) => {
  return async (dispatch, getState) => {
    dispatch(apiStart());

    const response = await fetch("https://api.stripe.com/v1/account_links", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      },
      body: encodeBody({
        account: id,
        refresh_url: "http://localhost:3000/register/signin",
        return_url: "http://localhost:3000/onboarding/step5",
        type: "account_onboarding",
      }),
    });
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      cb(ret.url);
    } else {
      errorHandler(ret?.error?.message);
    }
    dispatch(apiSuccess());
  };
};

export const retrieveAccount = () => {
  return async (dispatch, getState) => {
    dispatch(apiStart());

    const response = await fetch(
      "https://api.stripe.com/v1/accounts/" +
        localStorage.getItem("account_id"),
      {
        method: "get",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
      }
    );

    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      const bankDetails = ret?.external_accounts?.data[0];

      dispatch(
        setAccountDetails({
          bankDetails: {
            bank_name: bankDetails?.bank_name,
            routing_number: bankDetails?.routing_number,
            account_number: bankDetails?.last4,
          },
        })
      );
    } else {
      errorHandler(ret?.error?.message);
    }

    dispatch(apiSuccess());
  };
};

export const addCard = (token, cb = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        addCardLoading: true,
      })
    );

    const response = await fetch(
      "https://api.stripe.com/v1/customers/cus_JodDHqyuEq5OCg/sources",
      {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
        body: encodeBody({
          source: token,
        }),
      }
    );
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      toast.success("Card Added Successfully");
      cb();
      dispatch(getCards());
    } else {
      errorHandler(ret?.error?.message);
    }

    dispatch(
      setAccountDetails({
        addCardLoading: false,
      })
    );
  };
};

export const createCustomer = cb => {
  return async (dispatch, getState) => {
    dispatch(apiStart(true));

    const response = await fetch("https://api.stripe.com/v1/customers", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      },
    });
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      cb();
    } else {
      errorHandler(ret?.error?.message);
    }
    dispatch(apiSuccess());
  };
};

export const getCards = (cb = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        getCardsLoading: true,
      })
    );

    const response = await fetch(
      "https://api.stripe.com/v1/customers/cus_JodDHqyuEq5OCg/sources",
      {
        method: "get",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
      }
    );
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      cb(ret.data);
      dispatch(
        setAccountDetails({
          cards: ret.data?.filter(card => card?.object === "card"),
        })
      );
    } else {
      errorHandler(ret?.error?.message);
    }
    dispatch(
      setAccountDetails({
        getCardsLoading: false,
      })
    );
  };
};

export const setAccountDetails = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_ACCOUNT_DETAILS,
      payload,
    });
};

export const setEarningReports = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_EARNING_REPORTS,
      payload,
    });
};

export const setBankDetails = payload => {
  return dispatch =>
    dispatch({
      type: actionTypes.SET_BANK_DETAILS,
      payload,
    });
};

export const deleteCard = (cardId, cb = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        deleteCardLoading: true,
      })
    );

    const response = await fetch(
      "https://api.stripe.com/v1/customers/cus_JodDHqyuEq5OCg/sources/" +
        cardId,
      {
        method: "delete",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
      }
    );
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      errorHandler("Card Deleted Successfully");
      dispatch(
        setAccountDetails({
          selectedCard: undefined,
        })
      );
      cb(ret.data);
      dispatch(getCards());
    } else {
      errorHandler(ret?.error?.message);
    }
    dispatch(
      setAccountDetails({
        deleteCardLoading: false,
      })
    );
  };
};

export const generateACHBankAccountToken = cb => {
  return async (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        bankAccountLoading: true,
      })
    );
    const accountDetails =
      getState()?.onboarding?.accountDetails?.achBankDetails;

    const response = await fetch("https://api.stripe.com/v1/tokens", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
      },
      body: encodeTokenBody({
        country: "US",
        currency: "usd",
        account_holder_name: accountDetails?.ach_account_holder_name,
        account_holder_type: "individual",
        account_number: accountDetails?.ach_account_number,
        routing_number: accountDetails?.ach_routing_number,
      }),
    });

    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      dispatch(updateCustomer(ret.id));
    } else {
      errorHandler(ret.error.message);
    }
    dispatch(
      setAccountDetails({
        bankAccountLoading: false,
      })
    );
  };
};

export const updateCustomer = token => {
  return async (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        bankAccountLoading: true,
      })
    );
    const response = await fetch(
      "https://api.stripe.com/v1/customers/cus_JodDHqyuEq5OCg",
      {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
        body: encodeBody({
          description: "Add ACH Bank Account",
          source: token,
        }),
      }
    );
    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      successHandler("ACH Bank Added Successfully");
      dispatch(retrieveBankAccount());
    } else {
      errorHandler(ret?.error?.message);
    }
    dispatch(
      setAccountDetails({
        bankAccountLoading: false,
      })
    );
  };
};

export const retrieveBankAccount = (cb = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        getBankAccountLoading: true,
      })
    );

    const response = await fetch(
      `https://api.stripe.com/v1/customers/cus_JodDHqyuEq5OCg/sources/${localStorage.getItem(
        "ach_bank_id"
      )}`,
      {
        method: "get",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
      }
    );

    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      dispatch(
        setBankDetails({
          ach_bank_name: ret.bank_name,
          ach_account_holder_name: ret.account_holder_name,
          ach_routing_number: ret.routing_number,
          ach_account_number: "xxx xxx xxx " + ret.last4,
          ach_fetched: true,
          status: ret?.status,
        })
      );
    } else {
      errorHandler(ret?.error?.message);
    }

    dispatch(
      setAccountDetails({
        getBankAccountLoading: false,
      })
    );
  };
};

export const verifyBankAccount = (cb = () => {}) => {
  return async (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        bankAccountLoading: true,
      })
    );

    const response = await fetch(
      `https://api.stripe.com/v1/customers/cus_JodDHqyuEq5OCg/sources/${localStorage.getItem(
        "ach_bank_id"
      )}/verify`,
      {
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${process.env.REACT_APP_STRIPE_KEY}`,
        },
        body: `amounts[]=32&amounts[]=45`,
      }
    );

    const ret = await response.json();
    if (response.status >= 200 && response.status < 300) {
      successHandler("ACH Bank Verified Successfully");
      dispatch(retrieveBankAccount());
    } else {
      errorHandler(ret?.error?.message);
    }

    dispatch(
      setAccountDetails({
        bankAccountLoading: false,
      })
    );
  };
};

export const getBankDetailsForPhysician = () => {
  return dispatch => {
    dispatch(apiStart());
    api
      .getBankDetailsForPhysician(getUserData()?.id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          res?.data &&
            dispatch(
              setAccountDetails({
                bankDetails: res?.data[0],
              })
            );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const addBankDetailsForPhysician = cb => {
  return dispatch => {
    dispatch(apiStart());

    const payload = {
      doctor: getUserData()?.id,
      refresh_url: `https://${window.location.host}${getRegPath("/signin")}`,
      return_url: `https://${window.location.host}${getOnboardingPath(
        "/step4"
      )}`,
    };

    api
      .addBankDetailsForPhysician(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb(res?.data?.url);
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateBankDetailsForPhysician = (accountId, cb = () => {}) => {
  return dispatch => {
    dispatch(apiStart());

    const payload = {
      account_id: accountId,
      refresh_url: `http://${window.location.host}${getRegPath("/signin")}`,
      return_url: `http://${window.location.host}${getOnboardingPath(
        "/step4"
      )}`,
    };

    api
      .updateBankDetailsForPhysician(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb(res?.data?.url);
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const addPaymentMethod = (paymentMethodId, cb = () => {}) => {
  return dispatch => {
    const payload = {
      details_id: getUserData()?.id,
      payment_method_id: paymentMethodId,
    };

    api
      .attachPaymentMethod(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          successHandler("Card Successfully Added");
          cb();
          dispatch(getCustomerCardDetails());
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            addCardLoading: false,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getCustomerCardDetails = (cb = () => {}) => {
  return dispatch => {
    dispatch(
      setAccountDetails({
        getCardsLoading: true,
      })
    );

    api
      .getCustomerCardDetails(getUserData()?.id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          dispatch(
            setAccountDetails({
              paymentMethods: res.data || [],
            })
          );
          cb();
        } else {
          if (res.status_code !== 400) errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            getCardsLoading: false,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const deleteUserCardDetails = (cardId, cb = () => {}) => {
  return dispatch => {
    dispatch(
      setAccountDetails({
        deleteCardLoading: true,
      })
    );

    api
      .deleteUserCardDetails(cardId)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 204) {
          errorHandler("Card Deleted Successfully");
          dispatch(getCustomerCardDetails());
          dispatch(
            setAccountDetails({
              selectedCard: undefined,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            deleteCardLoading: false,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getSubscriptionPlanList = (cb = () => {}) => {
  return dispatch => {
    dispatch(apiStart());

    api
      .getSubscriptionPlanListForPhysician()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 204) {
          const responseObj = res.data.map(subscription => ({
            ...subscription,
            unit_amount: parseInt(subscription?.price_id?.unit_amount) / 100,
          }));
        dispatch(
            setAccountDetails({
              subscription: responseObj[0],
              subscriptions: responseObj,
            })
          );
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const addSubscriptionPlan = (price_id, type, cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        addSubscriptionLoading: true,
      })
    );

    let payload;

    if (type === "bank") {
      payload = {
        price_id,
        doctor_details: getUserData()?.id,
        subscription_id:
          getState()?.onboarding?.accountDetails?.subscription?.id,
        default_source:
          getState()?.onboarding?.accountDetails?.achBankDetails?.ach_bank_id,
      };
    } else if (type === "card") {
      payload = {
        price_id,
        doctor_details: getUserData()?.id,
        subscription_id:
          getState()?.onboarding?.accountDetails?.subscription?.id,
        default_payment_method:
          getState()?.onboarding?.accountDetails?.selectedCard?.id,
      };
    }

    api
      .addSubscriptionPlanForPhysician(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          !res?.data?.hosted_invoice_url &&
            successHandler("Subscription Purchased Successfully");
          cb(res?.data?.hosted_invoice_url);
          dispatch(getSubscriptionPlanList());
          dispatch(
            setAccountDetails({
              selectedCard: undefined,
              paymentError: undefined,
              is_subscription_exists: true,
            })
          );
          dispatch(getDoctorDetails());
        } else {
          type === "bank"
            ? dispatch(
                setAccountDetails({
                  paymentError: res.message[0],
                  is_subscription_exists: false,
                })
              )
            : errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            addSubscriptionLoading: false,
          })
        );
      })
      .catch(error => {
        dispatch(
          setAccountDetails({
            addSubscriptionLoading: false,
            is_subscription_exists: false,
          })
        );
        catchHandler(error, dispatch);
      });
  };
};

export const addACHBankDetails = (cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        bankAccountLoading: true,
      })
    );

    const accountDetails =
      getState()?.onboarding?.accountDetails?.achBankDetails;

    const payload = {
      doctor_details_id: getUserData()?.id,
      country: "US",
      currency: "usd",
      account_holder_name: accountDetails?.ach_account_holder_name,
      account_holder_type: "individual",
      account_number: accountDetails?.ach_account_number,
      routing_number: accountDetails?.ach_routing_number,
    };

    api
      .addACHBankDetails(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          successHandler("Bank Details Added Successfully");
          cb();
          dispatch(getCustomerBankDetails());
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            bankAccountLoading: false,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
        dispatch(
          setAccountDetails({
            bankAccountLoading: false,
          })
        );
      });
  };
};

export const payPersonlizedExperience = (cb = () => {}) => {
  return (dispatch, getState) => {
    dispatch(
      setAccountDetails({
        addSubscriptionLoading: true,
      })
    );

    const selectedCard =
      getState()?.onboarding?.accountDetails?.selectedCard?.id;

    const payload = {
      currency: "usd",
      doctor_details_id: getUserData()?.id,
      payment_method_id: selectedCard,
    };

    api
      .payPersonlizedExperience(payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          if (res.data.status === "succeeded") {
            successHandler("Personalized Purchased Successfully");
            dispatch(
              setPersonalisedExperience({
                is_paid: true,
              })
            );
            cb();
          } else if (res.data.status === "requires_action") {
            cb(res?.data);
          } else {
            errorHandler("Payment Failed. Please try again");
          }
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            addSubscriptionLoading: false,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const updateDoctorPaidDetails = (cb = () => {}) => {
  return dispatch => {
    dispatch(
      setAccountDetails({
        addSubscriptionLoading: true,
      })
    );

    api
      .updateDoctorPaidDetails(getUserData()?.id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          successHandler("Personalized Purchased Successfully");
          dispatch(
            setPersonalisedExperience({
              is_paid: true,
            })
          );
          cb();
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            addSubscriptionLoading: false,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getCustomerBankDetails = (cb = () => {}) => {
  return dispatch => {
    dispatch(
      setAccountDetails({
        getCardsLoading: true,
      })
    );

    api
      .getCustomerBankDetails(getUserData()?.id)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          if (res?.data && res?.data?.data?.length > 0) {
            const bankDetails = res?.data?.data[0];
            dispatch(
              setBankDetails({
                ach_bank_id: bankDetails?.id,
                ach_account_holder_name: bankDetails?.account_holder_name,
                ach_account_number: "xxx xxx xxx " + bankDetails?.last4,
                ach_routing_number: bankDetails?.routing_number,
                status: bankDetails?.status,
                ach_fetched: true,
              })
            );
          }
          cb();
        } else {
          if (res.status_code !== 400) errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            getCardsLoading: false,
            paymentError: undefined,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const deleteACHBankDetails = (bankId, cb = () => {}) => {
  return dispatch => {
    dispatch(
      setAccountDetails({
        deleteAccountLoading: true,
        paymentError: undefined,
      })
    );

    api
      .deleteACHBankDetails(bankId)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 204) {
          dispatch({ type: actionTypes.REMOVE_BANK_DETAILS });
          errorHandler("Bank Details Successfully Deleted");
        } else {
          if (res.status_code !== 400) errorHandler(res.message[0]);
        }
        dispatch(
          setAccountDetails({
            deleteAccountLoading: false,
          })
        );
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getSubscriptionDetail = (subscriptionId, cb = () => {}) => {
  return dispatch => {
    dispatch(apiStart());

    api
      .getSubscriptionDetail({ subscription_id: subscriptionId })
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 204) {
          cb();
        } else {
          if (res.status_code !== 400) errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const cancelSubscription = (subscriptionId, cb = () => {}) => {
  return dispatch => {
    dispatch(apiStart());

    api
      .cancelSubscription({ subscription_id: subscriptionId })
      .then(response => {
        const res = response.data;
        if (res.status_code === 200 || res.status_code === 204) {
          dispatch({ type: actionTypes.REMOVE_BANK_DETAILS });
          errorHandler("Subscription Successfully Cancelled ");
          dispatch(getSubscriptionPlanList());
          cb();
        } else {
          if (res.status_code !== 400) errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const createSetupIntent = (cb = () => {}) => {
  return dispatch => {
    api
      .setupIntent()
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          cb(res?.data);
        } else {
          errorHandler(res.message[0]);
          dispatch(
            setAccountDetails({
              addCardLoading: false,
            })
          );
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        catchHandler(error, dispatch);
      });
  };
};

export const getPaymentDetails = (
  startDate,
  endDate,
  searchValue = "",
  page=1
) => {
  return (dispatch, getState) => {
    dispatch(apiStart());
    

    const earningReports = getState().dashboard?.earningReports?.earningReports;
  

    const payload = {
      doctor_id: getUserData()?.id,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      
    };

    api
      .getPaymentDetails(searchValue, page, payload)
      .then(response => {
        const res = response.data;
        if (res.status_code === 200) {
          const resData = res?.data[0];

          let totalEarning = 0;
         
          [
            ...(page > 1
              ? [...earningReports, ...resData?.results]
              : resData?.results),
          ].forEach(earning => (totalEarning += parseInt(earning.amount)));
          let reports = {
            ...resData,
            total_pages: resData?.links?.total_pages,
            results:
              page > 1
                ? [...earningReports, ...resData?.results]
                : resData?.results,
            totalEarning,
          };

          dispatch(setEarningReports(reports));
        } else {
          errorHandler(res.message[0]);
        }
        dispatch(apiSuccess());
      })
      .catch(error => {
        console.log("error: ", error);
        catchHandler(error, dispatch);
      });
  };
};

export const searchEarningReports = q => {
  return (dispatch, getState) => {
    const earningReports =
      getState()?.dashboard?.earningReports?.earningReports;
    if (earningReports?.length>0) {
      const searchEarningReports = earningReports.filter(x => {
        return (
          x.first_name?.toLowerCase()?.includes(q?.toLowerCase()) ||
          x.last_name?.toLowerCase()?.includes(q?.toLowerCase())
        );
      });
  
      dispatch({
        type: actionTypes.SEARCH_EARNING_REPORTS,
        searchValue: q,
        search: searchEarningReports,
        total_pages: 1,
      });
    }
  };
};

export const emptyEarningReports = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.EMPTY_EARNING_REPORTS,
    });
  };
};
